export const APP_CONFIG = {
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    leavingMessage: {
        messageFull:
            'You are trying to leave the form without saving your changes, proceeding with this action will cause all changes to be lost.',
        messageShort: 'Proceeding with this action will cause all changes to be lost.',
        header: 'Unsaved changes'
    },
    cityDefault: 'Tauranga',
    cityOptions: [
        { label: 'Tauranga', value: 'Tauranga', enabled: true },
        { label: 'Whangarei', value: 'Whangarei', enabled: true }
    ],
    cityOptionsForeman: [{ label: 'Tauranga', value: 'Tauranga', enabled: true }],
    labourCodesWithTime: ['None', 'Accepted', 'Injured at work', 'Sick'],
    hireInValidation: 'hire in'
}
